(function ($) {
  const $newsletter = $('.field--name-dynamic-block-fieldparagraph-mailchimp');
  const $newsletterContainer = $newsletter.closest('.layout__region--content');
  const $newsletterLabel = $newsletter.find('label[for=edit-mergevars-email');
  const $newsletterInput = $newsletter.find('input[type=email]');

  $newsletterContainer.addClass('newsletter');
  $newsletterInput.attr('placeholder', $newsletterLabel.text());
  $newsletterLabel.hide();
})(jQuery);